module.exports = __webpack_public_path__ + "e145063b45a2f0a998ee5a321c66552a.svg";